var _defs, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew245({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 7.1,
    r: 6.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,13.22A6,6,0,0,1,4.31,12V15h7.38V12A6,6,0,0,1,8,13.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.34,5.22h.45V6.9h0c.09-.13.18-.26.27-.37L5.15,5.22h.56L4.44,6.7l1.37,2H5.27L4.12,7l-.33.38V8.71H3.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.79,8.71,5.91,5.22h.47L6.8,7c.1.43.19.87.26,1.2h0A11.79,11.79,0,0,1,7.35,7l.47-1.76h.47L8.71,7c.1.41.19.83.25,1.2H9C9,7.8,9.14,7.42,9.25,7l.46-1.76h.46l-1,3.49H8.71L8.27,6.89A11,11,0,0,1,8,5.75H8a10.11,10.11,0,0,1-.27,1.14l-.5,1.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.56,5H11V6.6h0a.76.76,0,0,1,.32-.32,1,1,0,0,1,.47-.13c.34,0,.87.2.87,1.07V8.71h-.45V7.27c0-.4-.15-.75-.58-.75a.65.65,0,0,0-.61.46.48.48,0,0,0,0,.22V8.71h-.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew245);
export default __webpack_public_path__ + "static/media/Symbolpack_New_245.21e18451b2f07609a3ea1065b1e7de94.svg";
export { ForwardRef as ReactComponent };